'use client';

import { useEffect, useRef } from 'react';
import { useWindowSize } from 'usehooks-ts';

export function SiteHeaderWrapper({ children }: { children: React.ReactNode }) {
  const ref = useRef<HTMLDivElement>(null);

  // update a css variable with the height of the header
  const { width } = useWindowSize();
  useEffect(() => {
    if (ref.current) {
      const headerHeight = ref.current.offsetHeight;
      document.documentElement.style.setProperty(
        '--site-header-height',
        `${headerHeight}px`,
      );
    }
  }, [width]);

  return (
    <div
      className="site-header-wrapper sticky left-0 right-0 top-0 z-20 shadow"
      ref={ref}
    >
      {children}
    </div>
  );
}
